export default {
    // 管理组-点击
    ADMIN_GROUP_CLICK: 'admin_group_click',
    // 管理员-tab-切换
    ADMIN_GROUP_TAB_CLICK: 'admin_group_tab_click',
    // 管理组-添加
    ADMIN_GROUP_ADD: 'admin_group_add',
    // 管理组-添加-确定
    ADMIN_GROUP_ADD_CONFIRM: 'admin_group_add_confirm',
    // 管理组-编辑（配置变更）
    ADMIN_GROUP_EDIT: 'admin_group_edit',
    // 创建者转交-点击
    OWNER_TRANSFER_CLICK: 'owner_transfer_click',
    // 创建者转交-成功
    OWNER_TRANSFER_SUCCESS: 'owner_transfer_success',
    // 应用安装
    APP_INSTALL: 'app_install',
    // 插件安装-确认
    PLUGIN_INSTALL_CONFIRM: 'plugin_install_confirm',
    // 插件安装-暂不安装
    PLUGIN_INSTALL_JUMP: 'plugin_install_jump',
    // 模版中心 - 安装
    FA_DETAIL_INSTALL: 'fa_detail_install',
    // 插件-安装
    PLUGIN_INSTALL: 'plugin_install',
    // 安装插件-取消勾选
    PLUGIN_INSTALL_CHECK_DISABLE: 'plugin_install_check_disable',
    USAGE_MODE: 'usage_mode',
    NAV_TOOLBAR_CLICK: 'nav_toolbar_click',
    MEMBER_VOLUNTARILY_LEFT_SUCCESS: 'member_voluntarily_left_success',
    VIEW_DOCK_MENU: 'view_dock_menu',
    // 九宫格菜单内按钮点击
    DOCK_MENU_BUTTON_CLICK: 'dock_menu_button_click',
    // 头像菜单二级按钮点击
    HEAD_MENU_BUTTON_CLICK: 'head_menu_button_click',
    OPEN_PLATFORM_ENTER: 'open_platform_enter',
    // 高级功能限制弹窗
    VIP_LIMIT_ALERT: 'vip_limit_alert',
    // 高级功能限制弹窗-点击查看使用详情
    USAGE_LIMIT_WARNING_DETAILS_CLICK: 'usage_limit_warning_details_click',
    // 进入通讯录
    CONTACTS_VIEW_FROM_DASHBOARD: 'contacts_view_form_dashboard',
    // 访问通讯录普通管理组
    CONTACTS_ADMIN_ORGANIZATION_VISIT: 'contacts_admin_organization_visit',
    // 进入知识库
    ENTER_KMS: 'enter_kms',
    AUTH_TYPE_SELECT: 'auth_type_select',
    // 选择企业认证
    AUTH_TYPE_CORP: 'auth_type_corp',
    // 选择个人认证
    AUTH_TYPE_OWNER: 'auth_type_owner',
    // 企业认证-阅读协议-点击下一步
    AUTH_CORP_PROTOCOL_NEXT: 'auth_corp_protocol_next',
    // 企业认证-填写信息-点击下一步
    AUTH_CORP_INFO_NEXT: 'auth_corp_info_next',
    REGISTER_LINK_SUCCESS_INVITE: 'register_link_success_invite',
    SELF_REG_SUCCESS: 'self_reg_success',
    // 注册时，触达第二步创建团队页面
    CREATE_CORP_VISIT: 'create_corp_visit',
    // 注册时，触达第三步个人信息页
    ARRIVE_PERSONAL_INFO: 'arrive_personal_info',
    // 注册时完成第三步的个人画像收集
    SELF_PORTRAIT_COMPLETE: 'self_portrait_complete',
    // 注册页访问
    REG_PAGE_VISIT: 'reg_page_visit',
    DELETE_ACCOUNT_BTN_CLICK: 'delete_account_btn_click',
    LAND_SECOND_CHECK_SWITCH: 'land_second_check_switch',
    CROSSCORP_BANNER_LEARN_CLICK: 'crosscorp_banner_learn_click',
    SAME_TIME_LOGIN_LIMIT_SWITCH: 'same_time_login_limit_switch',
    // 点击立即注销且注销成功时触发
    DELETE_ACCOUNT_NOW: 'delete_account_now',
    // 账号绑定-帆软通行证
    ACCOUNT_BIND_FANRUAN_PASS: 'account_bind_fanruan_pass',
    // 账号绑定-帆软通行证-解绑
    ACCOUNT_BIND_FANRUAN_PASS_UNBIND: 'account_bind_fanruan_pass_unbind',
    // 通过帆软通行证登录简道云
    LOGIN_BY_FANRUAN_PASS: 'login_by_fanruan_pass',
    // 点击取消注销且取消成功时触发
    DELETE_ACCOUNT_WITHDRAW: 'delete_account_withdraw',
    PERSONAL_ACCOUNT_CHANGE: 'personal_account_change',
    // 方案模板筛选
    FA_FILTER: 'fa_filter',
    // 方案模板-点击「更多模板」
    FA_FIND_MORE_CLICK: 'fa_find_more_click',
    // 工作台模板中心-搜索栏-预设词-点击
    FA_CENTER_FILTER_PRESET_CLICK: 'fa_center_filter_preset_click',
    // 方案模板-模板详情页
    FA_DETAIL_VIEW: 'fa_detail_view',
    // 模板详情页-点击「分享」
    FA_DETAIL_SHARE_CLICK: 'fa_detail_share_click',
    // 模板详情页-点击「安装模板」
    FA_DETAIL_INSTALL_CLICK: 'fa_detail_install_click',
    // 模板详情页-点击「相关模板」
    FA_DETAIL_TEMPLATE_CLICK: 'fa_detail_template_click',
    // 访问模板外链
    FA_SHARE_LINK_VIEW: 'fa_share_link_view',
    // 在模板外链页面安装模板
    FA_SHARE_LINK_INSTALL: 'fa_share_link_install',
    // 个人设置-手机/邮箱/账号-解绑
    PERSONAL_ACCOUNT_UNBIND_CLICK: 'personal_account_unbind_click',
    // 个人设置-手机/邮箱/账号-解绑成功
    PERSONAL_ACCOUNT_UNBIND_SUCCESS: 'personal_account_unbind_success',
    // 企业管理-收起展开导航
    PROFILE_NAVIGATION: 'profile_navigation',
    // 企业管理—版本信息
    PROFILE_VERSION_INFO: 'profile_version_info',
    // 企业管理-企业协作-系统语言
    PROFILE_LANGUAGE_EDIT: 'profile_language_edit',
    // 企业管理-产品中心
    PROFILE_PRODUCT_CENTER: 'profile_product_center',
    // 管理后台-产品中心-子产品-启用/关闭
    PROFILE_PRODUCT_CENTER_SUBPRODUCT_SWITCH: 'profile_product_center_subproduct_switch',
    // 企业管理—企业信息
    PROFILE_CORP_INFO: 'profile_corp_info',
    // 管理后台-企业信息-立即完善
    PROFILE_CORP_INFO_IMPROVE: 'profile_corp_info_improve',
    // 企业管理—订单信息
    PROFILE_ORDER_INFO: 'profile_order_info',
    // 企业管理-权限查询
    PROFILE_PERMISSION_QUERY: 'profile_permission_query',
    // 权限查询-tab-切换
    PERM_QUERY_PRODUCT_TAB_SWITCH: 'perm_query_product_tab_switch',
    // 企业管理-产品设置
    PROFILE_PRODUCT_SET: 'profile_product_set',
    // 企业管理-内部组织
    PROFILE_INNER_ORGANAZITION: 'profile_inner_organazition',
    // 企业管理-外部用户
    PROFILE_EXTERNAL_USER: 'profile_external_user',
    // 企业管理-互联组织
    PROFILE_EXTERNAL_ORGANAZITION: 'profile_external_organazition',
    // 企业管理—登录日志
    PROFILE_LOGIN_LOG: 'profile_login_log',
    // 企业管理—企业日志
    PROFILE_CORP_LOG: 'profile_corp_log',
    // 应用搭建子产品-开关-点击
    APPLICATION_BUILD_SWITCH_CLICK: 'application_build_switch_click',
    // 子产品-可用范围-点击
    PRODUCT_USABLE_RANGE: 'product_usable_range',
    // 内部组织-部门搜索
    DEPARTMENT_SEARCH: 'department_search',
    // 内部组织-切换部门/角色
    DEPARTMENT_ROLE_CLICK: 'department_role_click',
    // 内部组织-角色搜索
    ROLE_SEARCH: 'role_search',
    // 邀请成员
    MEMBER_INVITE: 'member_invite',
    // 访问「互联组织」
    VISIT_CROP_COOP: 'visit_crosscrop',
    // 跳转互联组织无权限
    CORP_COOP_CLICK_ERROR: 'corp_coop_click_error',
    // 通讯录-我连接的企业-空状态新建连接
    CLICK_GUEST_BLANK_LINK: 'click_guest_blank_link',
    // 登录日志，点击导出日志
    LOGIN_LOG_EXPORT: 'login_log_export',
    // 企业日志，点击导出日志
    CORP_LOG_EXPORT: 'corp_log_export',
    // 成员转为离职
    MEMBER_RESIGNED: 'member_resigned',
    // 成员按部门导出
    MEMBER_LIST_EXPORT: 'member_list_export',
    // 用户选择成员、部门、角色
    MEMBERSELECT_CONTENT: 'memberselect_content',
    // 复制邀请公开链接或点击二维码
    MEMBER_INVITE_LINK_CLICK: 'member_invite_link_click',
    // 内部组织-部门树点击
    SPECIFIC_DEPARTMENT_CLICK: 'specific_department_click',
    // 点击工作交接按钮
    MEMBER_HANDOVER: 'member_handover',
    // 离职成员彻底删除
    RESIGNED_EMPLOYEE_DELETE: 'resigned_employee_delete',
    // 通讯录-角色-导入
    MEMBER_LIST_ROLE_IMPORT: 'member_list_role_import',
    // 通讯录-角色-导出
    MEMBER_LIST_ROLE_EXPORT: 'member_list_role_export',
    // 内部组织-成员搜索
    MEMBER_LIST_SEARCH: 'member_list_search',
    // 外部用户-邀请成员
    EXTERNAL_USER_INVITE: 'external_user_invite',
    // 外部用户-导出成员
    EXTERNAL_USER_EXPORT: 'external_user_export',
    // 外部用户-搜索成员
    EXTERNAL_USER_SEARCH: 'external_user_search',
    // 外部用户-创建角色成功
    EXTERNAL_USER_ROLE_ADD: 'external_user_role_add',
    // 工作交接弹窗点击转交
    HANDOVER_FORWARD: 'handover_forward',
    // 企业标签-新建连接
    LABEL_CLICK_GUEST_LINK: 'label_click_guest_link',
    // 申请代管通讯录
    APPLY_ESCROW_ADDRESS_CLICK: 'apply_escrow_address_click',
    // 针对代管通讯录的企业, 点击添加外部对接人
    ESCROW_DOCK_ADD_CLICK: 'escrow_dock_add_click',
    // 通讯录新建连接，批量导入邀请，导入文件成功
    GUEST_LINK_EXCEL_UPLOAD_SUCCESS: 'guest_link_excel_upload_success',
    // 通讯录新建连接，批量导入邀请，导入文件失败
    GUEST_LINK_EXCEL_UPLOAD_FAIL: 'guest_link_excel_upload_fail',
    // 通讯录新建连接，批量导入邀请，点击重新上传
    GUEST_LINK_EXCEL_UPLOAD_AGAIN: 'guest_link_excel_upload_again',
    // 通讯录新建连接，批量导入邀请，点击下载导入模板
    GUEST_LINK_EXCEL_TEMPLATE_DOWNLOAD: 'guest_link_excel_template_download',
    // 通讯录新建连接，批量导入邀请，点击选择文件的热区
    GUEST_LINK_EXCEL_FILE_CLICK: 'guest_link_excel_file_click',
    // 通讯录新建连接，批量导入邀请，开始导入文件
    GUEST_LINK_EXCEL_UPLOAD_START: 'guest_link_excel_upload_start',
    // 新建连接 -> 批量导入 -> 了解更多
    GUEST_LINK_EXCEL_LEARN: 'guest_link_excel_learn',
    // excel成功导入客体企业后, 复制链接
    EXCEL_IMPORT_LINK_COPY_CLICK: 'excel_import_link_copy_click',
    // excel成功导入客体企业后, 点二维码
    EXCEL_IMPORT_LINK_CODE_CLICK: 'excel_import_link_code_click',
    // 通讯录新建连接，公开链接邀请，点击下载二维码
    GUEST_LINK_INVITE_CODE_DOWNLOAD: 'guest_link_invite_code_download',
    // 点击 我方对接人
    LIST_DOCKER_CLICK: 'list_docker_click',
    // 点击 外部对接人
    GUEST_LIST_DOCKER_CLICK: 'guest_list_docker_click',
    // 通讯录点击 我连接的企业
    CLICK_HOST_LIST: 'click_host_list',
    // 成员邀请-公开邀请链接-开关
    MEMBER_LINK_SWITCH: 'member_link_switch',
    // 成员邀请-公开邀请链接-有效期配置
    MEMBER_LINK_INVITE_PERIOD: 'member_link_invite_period',
    // 成员邀请-批量导入
    MEMBER_INVITE_MULTI: 'member_invite_multi',
    // 恢复在职-邀请
    REEMPLOYMENT_MEMBER_INVITE_SUCCESS: 'reemployment_member_invite_success',
    // 手机号/邮箱邀请成员
    MEMBER_INVITE_OF_PHONE_EMAIL: 'member_invite_of_phone_email',
    // 导入免审-成员导入方式
    MEMBER_JOIN_METHOD_CHOOSE: 'member_join_method_choose',
    // 通讯录 - 部门成员 - 操作
    MEMBER_MORE_CLICK: 'member_more_click',
    // 通讯录 - 成员状态筛选器切换
    MEMBER_STATUS_CLICK: 'member_status_click',
    // 通讯录新建连接，批量导入邀请，点击批量导入
    GUEST_LINK_EXCEL_CLICK: 'guest_link_excel_click',
    // 新建连接drawer， 切换到公开链接邀请tab
    GUEST_LINK_INVITE_CLICK: 'guest_link_invite_click',
    // 通讯录-我连接的企业-空状态帮助文档
    CLICK_GUEST_BLANK_LEARN: 'click_guest_blank_learn',
    // 通讯录-我连接的企业-新建连接
    CLICK_GUEST_LINK: 'click_guest_link',
    // 通讯录企业/对接人筛选为邀请中
    CORP_MEMBER_FILTER_INVITING: 'corp_member_filter_inviting',
    // 针对代管通讯录的企业, 添加对接人dialog中, 点击复制
    ESCROW_DOCK_LINK_COPY_CLICK: 'escrow_dock_link_copy_click',
    // 针对代管通讯录的企业, 添加对接人dialog中, 点击二维码
    ESCROW_DOCK_LINK_CODE_CLICK: 'escrow_dock_link_code_click',
    // 针对代管通讯录的企业, 添加外部对接人成功
    ESCROW_DOCK_ADD_SUCCESS: 'escrow_dock_add_success',
    // 企业管理-管理员
    PROFILE_ADMINISTRATOR: 'profile_administrator',
    // 企业管理-企业设置
    PROFILE_CORP_SET: 'profile_corp_set',
    // 企业管理-管理组查询
    PROFILE_MANAGE_GROUP_SEARCH: 'profile_manage_group_search',
    // 企业管理-权限组查询
    PROFILE_PERMISSION_GROUP_SEARCH: 'profile_permission_group_search',
    // 企业管理—使用统计
    PROFILE_USAGE_STATISTICS: 'profile_usage_statistics',
    // 企业管理—数据接口
    PROFILE_DATA_INTERFACE: 'profile_data_interface',
    // 多关键词搜索
    MULTI_KEYWORDS_SEARCH: 'multi_keywords_search',
    // 微信服务号集成开启
    WECHAT_INTEGRATION_OPEN: 'wechat_integration_open',
    // 微信服务号集成关闭
    WECHAT_INTEGRATION_CLOSE: 'wechat_integration_close',
    // 微信服务号集成解绑
    WECHAT_INTEGRATION_UNBIND: 'wechat_integration_unbind',
    // 微信服务号集成绑定
    WECHAT_INTEGRATION_BIND: 'wechat_integration_bind',
    // 微信服务号集成绑定成功
    WECHAT_INTEGRATION_BIND_SUCCESS: 'wechat_integration_bind_success',
    // 系统时区-修改，点击触发
    SYSTEM_TIME_ZONE_CHANGE: 'system_time_zone_change',
    /** 屏蔽提醒-点击 设置 */
    REMIND_BLOCK_CLICK: 'remind_block_click',
    /** 提醒屏蔽- 保存-记录人员数量 */
    REMIND_BLOCK_PERSON_NUMBER: 'remind_block_person_number',
    // 开启/关闭全局水印
    GLOBAL_WATERMARK: 'global_watermark',
    // 通讯录新建连接，公开链接邀请，点击分享
    GUEST_LINK_SHARE_CLICK: 'guest_link_share_click',
    // 通讯录新建连接，公开链接邀请，点击链接二维码
    GUEST_LINK_INVITE_CODE_CLICK: 'guest_link_invite_code_click',
    // 新建连接  -> 公开链接  -> 删除
    GUEST_LINK_INVITE_DELETE: 'guest_link_invite_delete',
    // 新建连接 -> 公开链接 -> 了解更多
    GUEST_LINK_INVITE_LEARN: 'guest_link_invite_learn',
    // 新建连接  -> 公开链接  -> 添加
    GUEST_LINK_INVITE_ADD: 'guest_link_invite_add',
    // 新建连接  -> 公开链接  -> 编辑
    GUEST_LINK_INVITE_EDIT: 'guest_link_invite_edit',
    // 新建连接  -> 公开链接  -> switch
    GUEST_LINK_INVITE_OPEN_CLOSE: 'guest_link_invite_open_close',
    // 互联组织新手引导， 第三步视频计时
    GUIDE_VIDEO_QUIT: 'guide_video_quit',
    // 引导第三步->立刻邀请合作伙伴
    GUIDE_CLICK_GUEST_LINK: 'guide_click_guest_link',
    // 通讯录外部组织引导
    CROP_COOP_GUIDE: 'corp_coop_guide',
    // 点击「其他设置」
    CROSSCROP_OTHER_CLICK: 'crosscrop_other_click',
    // 通讯录 - 内部组织 - 左侧menu拖动resize
    INTERNAL_ADJUST_WIDTH: 'internal_adjust_width',
    // 管理员页面 - 筛选
    PROFILE_ADMINISTRATOR_FILTER: 'profile_administrator_filter',
    // 企业设置-企业风格，打开开关时
    CORP_STYLE_OPEN: 'corp_style_open',
    // 接口调试-点击开始调试
    API_TABS_CLICK: 'api_tabs_click',
    DEBUG_START_CLICK: 'debug_start_click',
    // 埋点安装
    PLUGIN_INSTALL_CLICK: 'plugin_install_click',
    // 插件试用
    PLUGIN_TRIAL_CLICK: 'plugin_trial_click',
    // 插件试用-配置
    TRIAL_PLUGIN_CONFIGURE: 'trial_plugin_configure',
    // 自建插件导入添加文件后触发
    PRIVATE_PLUGIN_ADD_SELECT: 'private_plugin_add_select',
    /** 自建插件导入更新 - 点击dropdown更新按钮 */
    PRIVATE_PLUGIN_UPDATE: 'private_plugin_update',
    /** 自建插件导入更新 - 点击查看代码 */
    PRIVATE_PLUGIN_FUNCTION_VIEW_CLICK: 'private_plugin_function_view_click',
    // 插件-了解更多
    PLUGIN_KNOW_MORE: 'plugin_know_more',
    // 插件-点击详情
    PLUGIN_DETAIL: 'plugin_detail',
    // 插件-提交需求
    PLUGIN_REQUIRE: 'plugin_require',
    //  插件-停用
    PLUGIN_OFF: 'plugin_off',
    // 插件-启用
    PLUGIN_ON: 'plugin_on',
    // 插件-删除
    PLUGIN_DELETE: 'plugin_delete',
    // 插件-新建
    PRIVATE_PLUGIN_CREATE: 'private_plugin_create',
    // 插件-保存插件属性
    PRIVATE_PLUGIN_SAVE_ATTR: 'private_plugin_save_attr',
    // 插件-保存插件设计
    PRIVATE_PLUGIN_SAVE_DESIGN: 'private_plugin_save_design',
    /** 自建插件发布 - drawer - 发布 */
    PRIVATE_PLUGIN_PUBLISH_CONFIRM: 'private_plugin_publish_confirm',
    /** 自建插件 - 申请发布插件 */
    PRIVATE_PLUGIN_PUBLISH: 'private_plugin_publish',
    /** 自建插件 OAuth - 点击 URL 进入配置弹窗 */
    PRIVATE_PLUGIN_OAUTH_URL_SET: 'private_plugin_oauth_url_set',
    /** 自建插件 OAuth - 配置 dialog 保存 */
    PRIVATE_PLUGIN_OAUTH_URL_CONFIRM: 'private_plugin_oauth_url_confirm',
    // 点击AI代码助手
    AI_CODE_HELPER_CLICK: 'ai_code_helper_click',
    // 切换AI代码助手 - runtime
    AI_CODE_HELPER_SWITCH: 'ai_code_helper_switch',
    // 发送消息
    AI_CODE_HELPER_SEND_MESSAGE: 'ai_code_helper_send_message',
    // 点击AI代码助手的生成结果
    AI_CODE_HELPER_RESULT_CLICK: 'ai_code_helper_result_click',
    // accept后保存
    AI_CODE_HELPER_AUTO_SAVE: 'ai_code_helper_auto_save',
    // 自建插件保存
    PLUGIN_CREATE_SAVE: 'plugin_create_save',
    // 自建插件 - 添加函数
    PLUGIN_CREATE_FUNC_ADD: 'plugin_create_func_add',
    // 访问自建插件
    PLUGIN_CREATE_PAGE_VISIT: 'plugin_create_page_visit',
    // 切换至插件管理TAB
    OPEN_PLATFORM_TAB_PLUGIN: 'open_platform_tab_plugin',
    // 切换至插件管理TAB
    OPEN_PLATFORM_TAB_MARKET: 'open_platform_tab_market',
    // 切换至开发文档TAB
    OPEN_PLATFORM_TAB_DOC: 'open_platform_tab_doc',
    // 访问API Key
    OPEN_PLATFORM_TAB_API_KEY: 'open_platform_tab_api_key',
    // 访问API Log
    OPEN_PLATFORM_TAB_API_LOG: 'open_platform_tab_api_log',
    // 访问第三方授权
    OPEN_PLATFORM_TAB_API_TP: 'open_platform_tab_api_tp',
    // 切换至 MCP 服务 TAB
    OPEN_PLATFORM_TAB_MCP: 'open_platform_tab_mcp',
    // 创建APIKEY
    API_KEY_CREATE: 'api_key_create',
    // 插件市场 - 进行搜索
    PLUGIN_MARKET_SEARCH_SUCCESS: 'plugin_market_search_success',
    // 插件市场 - 点击menu
    PLUGIN_MARKET_LEFT_TAB_CLICK: 'plugin_market_left_tab_click',
    // 插件市场 - 插件详情 - 助力上架
    HELP_GROUND_BUTTON_CLICK: 'help_ground_button_click',
    // 插件安装/试用成功
    PLUGIN_TRAIL_POP_CLICK: 'plugin_trail_pop_click',
    // 插件安装/试用后，配置
    PLUGIN_TRAIL_CONFIG_CLICK: 'plugin_trail_config_click',
    /** 插件 - 无操作权限alert */
    PLUGIN_PERMISSION_ALERT: 'plugin_permission_alert',
    /** 插件 - 无操作权限alert - 点击操作 */
    PLUGIN_PERMISSION_ALERT_CLICK: 'plugin_permission_alert_click',
    /** 插件市场 - 嵌入页访问 */
    PLUGIN_MARKET_IFRAME_VISIT: 'plugin_market_iframe_visit',
    /** 点击参数说明 */
    PARAMETER_DESCRIPTION_CLICK: 'parameter_description_click',
    /** 点击复制json样例代码 */
    CODE_COPY_CLICK: 'code_copy_click',
    /** 跳转api调试台 */
    API_DEBUG_JUMP: 'api_debug_jump',
    // 访问产品内部API文档
    API_DOC_VISITED: 'api_doc_visited',
    /** 插件详情页-点击行为 */
    PLUGIN_DETAIL_PAGE_CLICK: 'plugin_detail_page_click',
    /** 插件配置-新增配置 */
    PLUGIN_ADD_CONFIG: 'plugin_add_config',
    /** 插件配置-确认删除配置 */
    PLUGIN_DELETE_CONFIG: 'plugin_delete_config',
    /** 插件配置-确认保存成功；p3 为保存的配置个数 */
    PLUGIN_SAVE_CONFIG: 'plugin_save_config',
    /** 插件管理-拖拽 */
    PLUGIN_DRAG: 'plugin_drag',
    /** 插件管理-设置 */
    PLUGIN_SET: 'plugin_set',
    /** 自建插件管理-操作 */
    PRIVATE_PLUGIN_OPERATE: 'private_plugin_operate',
    /** 自建插件管理-拖拽 */
    PRIVATE_PLUGIN_DRAG: 'private_plugin_drag',
    /** 复制api key */
    API_KEY_COPY: 'api_key_copy',
    /** 开启api key */
    API_KEY_ON: 'api_key_on',
    /** 关闭api key */
    API_KEY_OFF: 'api_key_off',
    /** 复制api key */
    API_KEY_DUPLICATE: 'api_key_duplicate',
    /** 删除api key */
    API_KEY_DELETE: 'api_key_delete',
    /** 添加ip */
    API_KEY_IP_SET: 'api_key_ip_set',
    /** 保存api key */
    API_KEY_SAVE: 'api_key_save',
    /** 开启 MCP 服务 */
    MCP_SERVICE_ON: 'mcp_service_on',
    /** 关闭 MCP 服务 */
    MCP_SERVICE_OFF: 'mcp_service_off',
    /** 点击创建 MCP 服务 */
    MCP_SERVICE_CREATE: 'mcp_service_create',
    /** 配置 MCP 服务弹窗 - 点击创建 */
    MCP_SERVICE_CREATE_CLICK: 'mcp_service_create_click',
    /** 配置 MCP 服务 - 授权并成功创建；p1 为授权有效天数，unlimited 表示无限制 */
    MCP_SERVICE_AUTH: 'mcp_service_auth',
    /** MCP 授权页 - 授权外部连接器成功 */
    MCP_SERVICE_AUTH_CONNECTOR: 'mcp_service_auth_connector',
    /** MCP 服务 - 修改成功；p1 为授权有效天数，unlimited 表示无限制 */
    MCP_SERVICE_EDIT: 'mcp_service_edit',
    /** MCP 服务 - 复制 JSON 或服务器 URL */
    MCP_SERVICE_COPY: 'mcp_service_copy',
    /** MCP 服务 - 添加至 Cursor / VS Code */
    MCP_SERVICE_ADD_TO: 'mcp_service_add_to',
    /** MCP 服务 - 重新授权成功 */
    MCP_SERVICE_RE_AUTH: 'mcp_service_re_auth',
    /** MCP 服务 - 删除 */
    MCP_SERVICE_DELETE: 'mcp_service_delete',
    /** MCP 服务 - 重置链接 */
    MCP_SERVICE_RESET: 'mcp_service_reset',
    /** MCP 服务 - 申请需审核能力 */
    MCP_SERVICE_REQUIRE_CAPABILITY: 'mcp_service_require_capability',
    /** MCP 服务 - 管理员勾选需审核能力（免审成功） */
    MCP_SERVICE_ADMINISTRATOR_REQUIRE_CAPABILITY: 'mcp_service_administrator_require_capability',
    /** MCP 服务 - 访问审核列表 */
    MCP_SERVICE_AUDIT_LIST: 'mcp_service_audit_list',
    /** MCP 服务 - 审批同意/拒绝成功 */
    MCP_SERVICE_REVIEW: 'mcp_service_review',
    /** MCP 服务 - 点击调用日志 */
    MCP_SERVICE_LOG: 'mcp_service_log',
    /** MCP 服务 - 开启时弹出协议弹窗 */
    MCP_SERVICE_AGREEMENT: 'mcp_service_agreement',
    /** MCP 服务 - 取消已通过的需审核能力 */
    MCP_SERVICE_CAPABILITY_CANCEL: 'mcp_service_capability_cancel',
    // 表单、字段通用搜索
    ENTRY_FIELD_SEARCH: 'entry_field_search',
    // 独享版登录页-企业登录
    SELF_HOSTED_CORP_LOGIN: 'self_hosted_corp_login',
    // 个人设置-语言-修改
    ACCOUNT_SET_LANGUAGE_EDIT: 'account_set_language_edit',
    // 系统区域-设置
    SYSTEM_LOCALE_SET: 'system_locale_set',
    // 数据源市场
    DATA_SOURCE_MARKET: 'data_source_market',
    // 数据源市场 - 详情drawer
    DATA_SOURCE_DETAIL: 'data_source_detail',
    // 数据源市场 - 详情drawer - 点击行为
    DATA_SOURCE_DETAIL_PAGE_CLICK: 'data_source_detail_page_click',
    // 数据源市场 - 详情drawer - 试用成功的alert点击行为
    DATA_SOURCE_DETAIL_PAGE_POPUP_CLICK: 'data_source_detail_page_popup_click',
    // 数据源市场 - 搜索
    DATA_SOURCE_MARKET_SEARCH: 'data_source_market_search',
    // 数据源管理
    DATA_INTEGRATE_VISIT: 'data_integrate_visit',
    // 数据源市场 - 创建同步表
    DATA_INTEGRATE_CREATE_SYNC_TABLE: 'data_integrate_create_sync_table',
    // 创建同步表 - 配置来源（下一步）
    SYNC_TABLE_SET_SOURCE: 'sync_table_set_source',
    // 创建同步表 - 配置目标（下一步）
    SYNC_TABLE_SET_END: 'sync_table_set_end',
    // 创建同步表 - 配置同步细节（创建）
    SYNC_TABLE_SET_SYNC_DETAIL: 'sync_table_set_sync_detail',
    // 数据源管理 - 创建数据连接
    DATA_INTEGRATE_CREATE_DATA_CONNECT: 'data_integrate_create_data_connect',
    // 数据连接 - 保存
    DATA_CONNECT_SAVE: 'data_connect_save',
    // 同步表管理 - 各种操作
    SYNC_TABLE_MGMT: 'sync_table_mgmt',
    // 同步表管理 - 删除确认
    SYNC_TABLE_DELETE_CONFIRM: 'sync_table_delete_confirm',
    // 同步表管理 - 搜索成功
    SYNC_TABLE_SEARCH_SUCCESS: 'sync_table_search_success',
    // 同步表管理 - 批量操作
    SYNC_TABLE_BATCH_OPERATE: 'sync_table_batch_operate',
    // 数据连接管理 - 各种操作
    DATA_CONNECT_MAMT: 'data_connect_mamt',
    // 数据连接管理 - 删除确认
    DATA_CONNECT_DELETE_CONFIRM: 'data_connect_delete_confirm',
    // 数据连接管理 - 搜索成功
    DATA_CONNECT_SEARCH_SUCCESS: 'data_connect_search_success',
    // 创建连接/同步表时 - 数据源选择操作
    SYNC_TABLE_SET_SOURCE_NEW_CLICK: 'sync_table_set_source_new_click',
    /** 创建集成应用 */
    INTEGRATED_APP_CREATE: 'integrated_app_create',
    /** 创建集成应用 - 创建 */
    INTEGRATED_APP_CREATE_CLICK: 'integrated_app_create_click',
    /** 创建集成应用 - 取消 */
    INTEGRATED_APP_CANCEL_CLICK: 'integrated_app_cancel_click',
    /** 创建集成应用 - 开关 */
    INTEGRATED_APP_SWITCH: 'integrated_app_switch',
    /** 创建集成应用 - 进入主页 */
    INTEGRATED_APP_ENTER: 'integrated_app_enter',
    /** 创建集成应用 - 删除 */
    INTEGRATED_APP_DELETE: 'integrated_app_delete',
    /** 创建集成应用 - 编辑 */
    INTEGRATED_APP_EDIT: 'integrated_app_edit',
    /** 点击单点登录配置 */
    SSO_CONFIG: 'sso_config',
    /** 自建插件-管理插件依赖 */
    PRIVATE_PLUGIN_DEPENDNCY_MANAGE: 'private_plugin_dependncy_manage',
    /** 自建插件-新建插件依赖 */
    PRIVATE_PLUGIN_DEPENDNCY_CREATE: 'private_plugin_dependncy_create',
    /** 自建插件-新建插件依赖-选择环境 */
    PRIVATE_PLUGIN_DEPENDNCY_CREATE_SELECT: 'private_plugin_dependncy_create_select',
    /** 自建插件-删除自定义环境 */
    PRIVATE_PLUGIN_DEPENDNCY_DELETE: 'private_plugin_dependncy_delete',
    /** 自建插件-自定义环境-安装并部署 */
    PRIVATE_PLUGIN_DEPENDNCY_DEPLOYMENT: 'private_plugin_dependncy_deployment',
    /** 自建插件-自定义环境-部署/取消 */
    PRIVATE_PLUGIN_DEPENDNCY_DEPLOYMENT_OPERATE: 'private_plugin_dependncy_deployment_operate',
    /** 自建插件-自定义环境-部署情况 */
    PRIVATE_PLUGIN_DEPENDNCY_DEPLOYMENT_STATUS: 'private_plugin_dependncy_deployment_status',
    /** 自建插件-自定义环境-查看引用视图 */
    PRIVATE_PLUGIN_DEPENDNCY_REFERENCE_VIEW: 'private_plugin_dependncy_reference_view',
    /** 自建插件-自定义环境-第三方依赖安装日志 */
    PRIVATE_PLUGIN_DEPENDNCY_INSTALLATION_LOG: 'private_plugin_dependncy_installation_log',
    /** 自建插件-自定义环境-第三方依赖安装日志-查询 */
    PRIVATE_PLUGIN_DEPENDNCY_INSTALLATION_LOG_QUERY:
        'private_plugin_dependncy_installation_log_query',
    /** 自建插件-自定义环境-第三方依赖安装日志-查看 */
    PRIVATE_PLUGIN_DEPENDNCY_INSTALLATION_LOG_VIEW:
        'private_plugin_dependncy_installation_log_view',
    /** 自建插件-执行环境-切换 */
    PRIVATE_PLUGIN_DEPENDNCY_SWITCH: 'private_plugin_dependncy_switch',
    /** 邀请成员-填写更多信息-点击 */
    MEMBER_INVITE_MORE_INFO: 'member_invite_more_info',
    /** 邀请成员-手动添加成员-填写的预设字段 */
    MEMBER_INVITE_DEFAULT_FIELD: 'member_invite_default_field',
    /** 成员表格可见字段 */
    MEMBER_LIST_VISIBLE_FIELD: 'member_list_visible_field',
    /** 成员表格-批量修改信息 */
    MEMBER_LIST_INFO_EDIT: 'member_list_info_edit',
    /** 成员表格-设置字段显隐 */
    MEMBER_LIST_FIELD_VISIBLE: 'member_list_field_visible',
    /** 成员表格-设置字段顺序 */
    MEMBER_LIST_FIELD_SORT: 'member_list_field_sort',
    /** 成员表格-调整部门 */
    MEMBER_LIST_DEPT_ADJUST: 'member_list_dept_adjust',
    /** 成员信息详情保存 */
    MEMBER_LIST_DETAIL_SAVE: 'member_list_detail_save',
    /** 企业管理-成员信息管理 */
    PROFILE_MEMBER_INFO: 'profile_member_info',
    /** 企业管理-成员信息管理-编辑权限 */
    PROFILE_MEMBER_INFO_EDIT: 'profile_member_info_edit',
    /** 个人设置修改预设字段 */
    PERSONAL_SET_FIELD: 'personal_set_field',
    /** 邀请成员-批量导入成员-填写的预设字段 */
    MEMBER_INVITE_MULTI_DEFAULT_FIELD: 'member_invite_multi_default_field',
    /** 成员卡片设置－进入字段展示 */
    MEMBER_CARD_SETTINGS_VIEW: 'member_card_settings_view',
    /** 成员卡片设置－修改可见字段 */
    MEMBER_CARD_SETTINGS_FIELD_TOGGLE: 'member_card_settings_field_toggle',
    /** 成员卡片设置－点击显示成员卡片 */
    MEMBER_CARD_SETTINGS_CLICK: 'member_card_settings_click',
    /** 成员卡片设置－悬浮显示成员卡片 */
    MEMBER_CARD_SETTINGS_HOVER: 'member_card_settings_hover',
    // 成员信息表-新增自定义字段
    MEMBER_LIST_ADD_FIELD: 'member_list_add_field',
    // 成员信息表-新增预自定义字段-确定
    MEMBER_LIST_ADD_FIELD_CONFIRM: 'member_list_add_field_confirm',
    // 成员信息表-删除自定义字段-确定
    MEMBER_LIST_DELETE_FIELD: 'member_list_delete_field',
    // 知识问答-去配置-点击
    KMS_AI_QA_GO_TO_SET: 'kms_ai_qa_go_to_set'
};
